<template>
  <div class="row pb-5">
    <div v-for="(sensor, key) in selectedSensors" :key="key" class="col-6">
      <mz-gauge :id="key"
        :value="sensor.value"
        :valueFormatter="sensor.valueFormatter"
        :status="sensor.status"
        :marker="sensor.marker" 
        :header="sensor.label"
        :unit="sensor.unit"
        :min="sensor.min"
        :max="sensor.max"
        :icon="sensor.icon"
        :checks="sensor.checks"
        :labels="sensor.labels"
        :css="sensor.css"
        data-toggle="modal"
        :data-target="'#modal-' + key">
      </mz-gauge>
      <mz-modal :id="'modal-' + key">
        <mz-line-chart
          :icon="sensor.icon"
          :header="sensor.label"
          :ranges="sensor.valueRanges"
          :unit="sensor.unit"
          :min="sensor.min"
          :max="sensor.max"
          :id="'raw-' + key"
          :data="sensor.history"></mz-line-chart>
      </mz-modal>
    </div>
  </div>
</template>

<script>
import Gauge from '@/components/charts/Gauge'
import LineChart from '@/components/charts/LineChart'
import Modal from '@/components/modal/Modal'
import { mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'

export default {
  name: 'rawData',
  data () {
    return {
      title: 'Raw Data',
      icon: 'heartbeat',
      sensorKeys: [
        'acx',
        'acy',
        'acz',
        'spd',
        'trq',
        'tge',
        'toi',
        'loi',
        'woi',
        'coi'
      ]
    }
  },
  computed: {
    ...mapGetters(['sensors', 'dummy']),
    selectedSensors () {
      const selection = _.pick(this.sensors, this.sensorKeys)
      return selection
    },
    myValue () {
      return this.$store.state.dummyValue
    }
  },
  methods: {
    ...mapMutations(['setPageTitle'])
  },
  components: {
    mzGauge: Gauge,
    mzLineChart: LineChart,
    mzModal: Modal
  },
  created () {
    this.setPageTitle({ title: this.title, icon: this.icon })
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/views/raw-data/RawData.vue